export default "__VITE_ASSET__BFDdJY5I__"